import { type WorkspaceAgentComposerScopePill } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/usePrivateWorkspaceAgentComposerPills';

export type WorkspaceAgentComposerScopeKind = 'asset' | 'asset-stack' | 'board';

export type WorkspaceAgentComposerScopeChip = {
  kind: WorkspaceAgentComposerScopeKind;
  name: string;
  title: string;
};

const DEFAULT_SCOPE_NAME_MAX_LENGTH = 26;

const truncateEnd = (label: string, maxLength: number): string => {
  if (label.length <= maxLength) {
    return label;
  }

  return `${label.slice(0, maxLength - 1)}…`;
};

const formatScopeChipName = (firstName: string, count: number, maxLength = DEFAULT_SCOPE_NAME_MAX_LENGTH): string => {
  if (count <= 1) {
    return truncateEnd(firstName, maxLength);
  }

  const suffix = ` + ${count - 1} more`;
  const maxBase = maxLength - suffix.length;
  const base = truncateEnd(firstName, maxBase);

  return `${base}${suffix}`;
};

export const buildWorkspaceAgentComposerScopeChip = (
  pills: WorkspaceAgentComposerScopePill[],
): WorkspaceAgentComposerScopeChip | null => {
  const [firstPill] = pills;

  if (!firstPill) {
    return null;
  }

  if (firstPill.type === 'board') {
    const name = truncateEnd(firstPill.name, DEFAULT_SCOPE_NAME_MAX_LENGTH);

    return {
      kind: 'board',
      name,
      title: firstPill.name,
    };
  }

  const firstName = firstPill.name;
  const count = pills.length;
  const fullLabel = count <= 1 ? firstName : `${firstName} + ${count - 1} more`;

  return {
    kind: count <= 1 ? 'asset' : 'asset-stack',
    name: formatScopeChipName(firstName, count),
    title: fullLabel,
  };
};
